import React, { createContext, useContext, useReducer, useState } from "react";
import useFetch from "./useFetch";
import { API_URL } from "../constants/constants";
import { useAuth } from "./AuthContext";

const UserDataContext = createContext();

const UserDataProvider = (props) => {
  const [userData, setUserData] = useState();
  const { token, authDispatch } = useAuth();

  const getUser = useFetch({
    url: token && `User_Service/whoami`,

    headers: {
      Authorization: `JWT ${token}`,
    },

    trigger: token ? true : false,
    argFunc: (res) => {
      // if (res) {
      setUserData(res);
      // }
      // if (err) {
      //   // authDispatch({ type: "LOGOUT" });
      // }
    },
  });

  return (
    <>
      {token ? (
        <>
          {getUser.response && (
            <UserDataContext.Provider value={{ userData, getUser }} {...props}>
              {props.children}
            </UserDataContext.Provider>
          )}
        </>
      ) : (
        <UserDataContext.Provider value={{ userData }} {...props}>
          {props.children}
        </UserDataContext.Provider>
      )}
    </>
  );
};

const useUserData = () => useContext(UserDataContext);

export { useUserData, UserDataProvider };
